import { BellOutlined } from "@ant-design/icons";
import { Badge, Button, Input, Modal, Table, Tag } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { LogType } from "../../redux/Slices/Log/Log.util";
import { LogActions } from "../../redux/Store";
import { useAppDispatch, useTypedSelector } from "../../redux/redux-hooks";

const LogComponent = () => {
  // HOOKS
  const dispatch = useAppDispatch();

  const { logCount, pagedLogs } = useTypedSelector((state) => state.log);

  // STATES
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(LogActions.getLogCount({}));
  }, []);

  useEffect(() => {
    if (isModalVisible)
      dispatch(LogActions.getPagedLogs({ limit: 10, page: 1, search }));
    else dispatch(LogActions.getLogCount({}));
  }, [isModalVisible]);

  useEffect(() => {
    if (!pagedLogs.loading && pagedLogs.successful) {
      const newLastSeen =
        pagedLogs.payload.rows[0]?.createdAt ??
        moment().subtract(10, "year").format("YYYY-MM-DDTHH:mm:ss.000Z");

      if (newLastSeen) {
        const s = newLastSeen?.split(".");
        s[s.length - 1] = "999Z";

        dispatch(LogActions.updateLogSeen(s.join(".")));
      }
    }
  }, [pagedLogs]);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const onSearch = (text: string) => {
    setSearch(text);

    dispatch(LogActions.getPagedLogs({ limit: 10, page: 1, search: text }));
  };

  const typeColor = {
    [LogType.REGISTER]: "green",
    [LogType.UPDATE]: "gold",
    [LogType.DELETE]: "pink",
  };

  return (
    <>
      <Badge
        status="error"
        count={logCount.payload}
        className={"hidden-print d-flex notification-badge"}
      >
        <Button
          loading={logCount.loading}
          style={{ marginTop: "15px", color: "white" }}
          type="text"
          icon={<BellOutlined />}
          onClick={() => setIsModalVisible(true)}
        />
      </Badge>

      <Modal
        centered
        width={1300}
        title={<h5>Operation Logs</h5>}
        open={isModalVisible}
        onCancel={handleOk}
        footer={[]}
      >
        <div className="row">
          <div className="col-md-6">
            <Input.Search
              placeholder="Search user, activity, extra ...."
              value={search}
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>

          <div className="col-12">
            <Table
              size="small"
              dataSource={pagedLogs.payload.rows}
              loading={pagedLogs.loading}
              columns={[
                {
                  title: "#",
                  render: (value, record, index) => index + 1,
                },
                {
                  title: "User",
                  width: 150,
                  render: (value, record) => (
                    <Tag color="blue">
                      {record.busAdmin.firstName} {record.busAdmin.lastName}
                    </Tag>
                  ),
                },
                {
                  title: "Type",
                  dataIndex: "type",
                  render: (value: any, record) => (
                    <Tag color={typeColor[record.type]}>{value}</Tag>
                  ),
                },
                {
                  title: "Activity",
                  dataIndex: "activity",
                  width: 400,
                },
                {
                  title: "Extra",
                  dataIndex: "extra",
                  align: "center",
                  width: 200,
                },
                {
                  title: "Timestamp",
                  width: 150,
                  align: "center",
                  dataIndex: "createdAt",
                  render: (value) => (
                    <Tag>{moment(value).format("DD/MM/YYYY hh:mm A")}</Tag>
                  ),
                },
                {
                  title: "Device",
                  dataIndex: "device",
                  width: 300,
                  render: (value) => <i>{value}</i>,
                },
              ]}
              pagination={{
                current: pagedLogs.payload.page,
                pageSize: pagedLogs.payload.limit,
                total: pagedLogs.payload.count,
                onChange: (page, pageSize) => {
                  dispatch(
                    LogActions.getPagedLogs({
                      offset: page,
                      limit: pageSize,
                      search,
                    })
                  );
                },
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogComponent;
